import React, { useCallback } from 'react';
import copyToClipboard from 'copy-text-to-clipboard';

import styles from './Buttons.module.scss';

const CopyToClipboardButton = props => {
    const {className, content, children} = props;

    const handleClick = useCallback(() => {
        copyToClipboard(content);

        // TODO: replace strings
        console.warn('HARDCODED STRINGS HERE!!!');
        app.store.dispatch(app.actions.ui.toast.queue('Copied to clipboard'));
    }, [content]);

    return (
        <button type="button" className={[styles.Button, className].join(' ')} onClick={handleClick}>
            {children}
        </button>
    );
};

export default CopyToClipboardButton;
